export default __webpack_public_path__ + "static/media/grid_pattern.7d7d1ae4.svg";